<div class="modern-auth-wrapper">
    <div class="auth-container">
        <!-- Left Panel - Login Form -->
        <div class="auth-left-panel">
            <div class="login-content">
                <!-- Logo and Title -->
                <div class="brand-section">
                    <div class="logo">
                        <img src="assets/images/Logo.png" alt="Company Logo" class="brand-logo">
                    </div>
                    <div class="logo-container">
                        <h1 class="brand-title">Employee Portal</h1>
                        <!-- <p class="brand-sub">Synergy Portal</p> -->
                    </div>
                </div>

                <!-- Sign In Section -->
                <div class="signin-section">
                    <h2 class="signin-title">SIGN IN</h2>
                    <p class="signin-subtitle">Uniting Productivity, Simplifying Workflows</p>

                    <form [formGroup]="loginForm" class="login-form">
                        <!-- Username Field -->
                        <div class="form-group">
                            <label for="username" class="form-label">Username</label>
                            <input type="text" id="username" formControlName="username" class="form-input"
                                placeholder="Enter Username"
                                [class.error-input]="getLoginFormControls.username.touched && getLoginFormControls.username.errors">
                            <div *ngIf="getLoginFormControls.username.touched && getLoginFormControls.username.errors"
                                class="error-message">
                                <span *ngIf="getLoginFormControls.username.errors.required">Username is required</span>
                            </div>
                        </div>

                        <!-- Password Field -->
                        <div class="form-group">
                            <label for="password" class="form-label">Password</label>
                            <div class="password-wrapper">
                                <input [type]="showPassword ? 'text' : 'password'" id="password"
                                    formControlName="password" class="form-input" placeholder="Enter password"
                                    [class.error-input]="getLoginFormControls.password.touched && getLoginFormControls.password.errors">
                                <button type="button" class="password-toggle" (click)="togglePasswordVisibility()">
                                    <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                </button>
                            </div>
                            <div *ngIf="getLoginFormControls.password.touched && getLoginFormControls.password.errors"
                                class="error-message">
                                <span *ngIf="getLoginFormControls.password.errors.required">Password is required</span>
                            </div>
                        </div>

                        <!-- Sign In Button -->
                        <button type="submit" class="btn-signin" [disabled]="!loginForm.valid || !showBtn"
                            (click)="login()">
                            <div *ngIf="!showBtn" class="spinner-container">
                                <div class="spinner"></div>
                            </div>
                            <span *ngIf="showBtn">Sign in</span>
                        </button>
                        <!-- Forgot Password -->
                        <div class="forgot-password">
                            <span class="forgot-text">Forgot password? </span>
                            <a [routerLink]="['/reset-req']" class="reset-link">Click here to Reset</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- Right Panel -->
        <div class="auth-right-panel">
            <div class="illustration-placeholder">
                <img src="assets/images/rectangle.png" alt="Login Illustration" class="illustration-image">
            </div>

        </div>
    </div>
</div>